import { Component, Output, EventEmitter, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';

/**
 * quill editor
 * https://github.com/KillerCodeMonkey/ngx-quill
 * 
 * quill emoji
 * https://github.com/xingw-z/quill2-emoji
 */
import { EditorChangeContent, EditorChangeSelection } from 'ngx-quill';
import Quill from 'quill';


import * as Emoji from "quill2-emoji";
Quill.register("modules/emoji", Emoji);


import { WysiwygData } from '@core/models/wysiwyg-data.model';

@Component({
    selector: 'core-helpers-forms-wysiwyg-extended',
    templateUrl: './wysiwyg-extended.component.html',
    styleUrls: ['./wysiwyg-extended.component.scss']
})
export class HelperFormWysiwygExtendedComponent implements OnInit, OnChanges {

    @Input() placeholder: string = '';
    @Input() content: string = ''; // to use when set / clear content from parent components
    @Input() modules : any = [];
    @Input() emojis : boolean = true;
    @Input() replaceableContent: boolean = false; // dec-2023 <diego@twonas.com> when we want to replace content from parent.
    @Output() textChange = new EventEmitter<WysiwygData>();

    // public message: string = ''; // for test only
    // editor config modules.
    protected toolbarOptions = {
        container: [
          ['bold', 'italic', 'underline'], // default togglable buttons for font styles  
        ]
      }


    public editorModules: any = null;

    protected editor: Quill;

    protected allowedTags = ['br', 'p', 'strong', 'em', 'u', 'ul','ol', 'li', 'b'];

    ngOnInit():void {
        // could be removed
        if(this.emojis){
            this.toolbarOptions.container.push(['emoji']);
        }
  
        if(this.modules?.length > 0){
            this.modules.forEach(mod => this.toolbarOptions.container.push(mod));
        }
        this.editorModules = { 
            toolbar: this.toolbarOptions,
            "emoji-toolbar": this.emojis,
            // "emoji-textarea": this.emojis,
            // 'emoji-toolbar': true,
            // options to prevent tags in editor
            clipboard: {   
                allowed: {
                    tags: this.allowedTags,
                    attributes: []
                },
                keepSelection: true,
                substituteBlockElements: true,
                // hooks: {
                //     uponSanitizeElement(node, data, config) {
                //         console.log("NODEEE ",node);
                //     },
            }, 
        };
    }

    ngOnChanges(changes: SimpleChanges): void {
        // used when reset content from parent components
        if(changes.content && changes.content.currentValue == '' && this.editor){
            this.editor.setContents(this.editor.clipboard.convert({html:this.content}));
        }
        if (changes.content && this.replaceableContent && changes.content.currentValue != '' && this.editor ){
            this.editor.setContents(this.editor.clipboard.convert({html:this.content}));
        }
    }

    created(editor: Quill) {
        // console.log('editor-created', editor);
        this.editor = editor;
        this.editor.setContents(this.editor.clipboard.convert({html:this.content}));
    }

    changedEditor(event: EditorChangeContent | EditorChangeSelection) {
        // console.log('editor-change event: '+event.event, event)
        if(event.event == 'text-change'){
            let editorData = {
                html : event.html ? event.html.replace(/<\/?span[^>]*>/g,"") : '',
                text : event.text
            }
            // this.message = editorData.html; // for test only

            this.textChange.emit(editorData); // if we do here the replace, does not replace inside editor
        }
    }

}
